import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import React from "react";

export default function ApproveAllDialog({ open, handleClose, onApproveAll }) {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs">
      <DialogContent>
        <Alert severity="warning">
          <AlertTitle>Approve all matches?</AlertTitle>
          Approving all therapy schedules will seal the events, sending out appointment reminders to
          all participants.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button onClick={onApproveAll}>Approve All</Button>
      </DialogActions>
    </Dialog>
  );
}
